import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.00004 0.0358887H13C13.3682 0.0358887 13.6667 0.334369 13.6667 0.702555V11.3692C13.6667 11.7374 13.3682 12.0359 13 12.0359H1.00004C0.631854 12.0359 0.333374 11.7374 0.333374 11.3692V0.702555C0.333374 0.334369 0.631854 0.0358887 1.00004 0.0358887ZM12.3334 2.86117L7.04791 7.59456L1.66671 2.84652V10.7026H12.3334V2.86117ZM2.00768 1.36922L7.04131 5.81056L12.0007 1.36922H2.00768Z",
		fill: "currentColor"
	})
});
export default SvgEmail;
